// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AssignCoachingModalOrderFragment = {
  __typename?: 'Order';
  id: string;
  createdAt: number;
  coach: {
    __typename?: 'Coach';
    id: string;
    slug: string;
    tier: Types.SkuTier;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
    };
  };
  packageOrder?: {
    __typename?: 'OfferingPackage';
    id: string;
    name: string;
    slug?: string | null;
    imageLink?: string | null;
    prices?: Array<{
      __typename?: 'OfferingPackagePrice';
      sku?: string | null;
      tier?: Types.SkuTier | null;
      packageCoachingTime?: {
        __typename?: 'PackageCoachingTime';
        exactTimeInMinute?: number | null;
        estimate?: {
          __typename?: 'IntRange';
          start?: number | null;
          end?: number | null;
        } | null;
      } | null;
    }> | null;
    category?: { __typename?: 'Category'; id: string; slug: string } | null;
  } | null;
  hourlyOrder?: {
    __typename?: 'HourlyOrder';
    timeInMinute: number;
    sku?: { __typename?: 'Sku'; id: string; tier: Types.SkuTier } | null;
  } | null;
  subscriptionOrder?: {
    __typename?: 'SubscriptionOrder';
    timeInMinute: number;
    sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    customerSubscription: {
      __typename?: 'CustomerSubscription';
      id: string;
      nextCreditGrantAt?: number | null;
      sku: {
        __typename?: 'Sku';
        id: string;
        tier: Types.SkuTier;
        family: Types.SkuFamily;
      };
    };
  } | null;
};

export type AssignCoachingModalCoachingRelationshipFragment = {
  __typename?: 'CoachingRelationship';
  tier?: Types.SkuTier | null;
  coach: {
    __typename?: 'Coach';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
    coachingTimeSummary?: {
      __typename?: 'CoachingTimeSummary';
      totalActiveTime: number;
    } | null;
  };
  categories?: Array<{
    __typename?: 'Category';
    id: string;
    slug: string;
  }> | null;
};

export type AssignCoachingModalAssignPendingOrderMutationVariables =
  Types.Exact<{
    coachUrn: Types.Scalars['CoachUrn']['input'];
    orderUrn: Types.Scalars['OrderUrn']['input'];
  }>;

export type AssignCoachingModalAssignPendingOrderMutation = {
  __typename?: 'Mutation';
  assignPendingOrder: {
    __typename?: 'Order';
    id: string;
    createdAt: number;
    coach: {
      __typename?: 'Coach';
      id: string;
      slug: string;
      tier: Types.SkuTier;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      };
    };
    packageOrder?: {
      __typename?: 'OfferingPackage';
      id: string;
      name: string;
      slug?: string | null;
      imageLink?: string | null;
      prices?: Array<{
        __typename?: 'OfferingPackagePrice';
        sku?: string | null;
        tier?: Types.SkuTier | null;
        packageCoachingTime?: {
          __typename?: 'PackageCoachingTime';
          exactTimeInMinute?: number | null;
          estimate?: {
            __typename?: 'IntRange';
            start?: number | null;
            end?: number | null;
          } | null;
        } | null;
      }> | null;
      category?: { __typename?: 'Category'; id: string; slug: string } | null;
    } | null;
    hourlyOrder?: {
      __typename?: 'HourlyOrder';
      timeInMinute: number;
      sku?: { __typename?: 'Sku'; id: string; tier: Types.SkuTier } | null;
    } | null;
    subscriptionOrder?: {
      __typename?: 'SubscriptionOrder';
      timeInMinute: number;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
      customerSubscription: {
        __typename?: 'CustomerSubscription';
        id: string;
        nextCreditGrantAt?: number | null;
        sku: {
          __typename?: 'Sku';
          id: string;
          tier: Types.SkuTier;
          family: Types.SkuFamily;
        };
      };
    } | null;
  };
};

export const AssignCoachingModalOrderFragmentDoc = gql`
  fragment AssignCoachingModal_Order on Order {
    id
    createdAt
    coach {
      id
      slug
      user {
        id
        firstName
        lastName
      }
      tier
    }
    packageOrder {
      id
      name
      slug
      imageLink
      prices {
        sku
        packageCoachingTime {
          estimate {
            start
            end
          }
          exactTimeInMinute
        }
        tier
      }
      category {
        id
        slug
      }
    }
    hourlyOrder {
      timeInMinute
      sku {
        id
        tier
      }
    }
    subscriptionOrder {
      sku {
        id
        family
      }
      customerSubscription {
        id
        sku {
          id
          tier
          family
        }
        nextCreditGrantAt
      }
      timeInMinute
    }
  }
`;
export const AssignCoachingModalCoachingRelationshipFragmentDoc = gql`
  fragment AssignCoachingModal_CoachingRelationship on CoachingRelationship {
    coach {
      id
      user {
        id
        firstName
        lastName
        pictureLink
      }
      coachingTimeSummary {
        totalActiveTime
      }
    }
    tier
    categories {
      id
      slug
    }
  }
`;
export const AssignCoachingModalAssignPendingOrderDocument = gql`
  mutation AssignCoachingModal_AssignPendingOrder(
    $coachUrn: CoachUrn!
    $orderUrn: OrderUrn!
  ) {
    assignPendingOrder(coachUrn: $coachUrn, orderUrn: $orderUrn) {
      ...AssignCoachingModal_Order
    }
  }
  ${AssignCoachingModalOrderFragmentDoc}
`;
export type AssignCoachingModalAssignPendingOrderMutationFn =
  Apollo.MutationFunction<
    AssignCoachingModalAssignPendingOrderMutation,
    AssignCoachingModalAssignPendingOrderMutationVariables
  >;

/**
 * __useAssignCoachingModalAssignPendingOrderMutation__
 *
 * To run a mutation, you first call `useAssignCoachingModalAssignPendingOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCoachingModalAssignPendingOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCoachingModalAssignPendingOrderMutation, { data, loading, error }] = useAssignCoachingModalAssignPendingOrderMutation({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *      orderUrn: // value for 'orderUrn'
 *   },
 * });
 */
export function useAssignCoachingModalAssignPendingOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignCoachingModalAssignPendingOrderMutation,
    AssignCoachingModalAssignPendingOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignCoachingModalAssignPendingOrderMutation,
    AssignCoachingModalAssignPendingOrderMutationVariables
  >(AssignCoachingModalAssignPendingOrderDocument, options);
}
export type AssignCoachingModalAssignPendingOrderMutationHookResult =
  ReturnType<typeof useAssignCoachingModalAssignPendingOrderMutation>;
export type AssignCoachingModalAssignPendingOrderMutationResult =
  Apollo.MutationResult<AssignCoachingModalAssignPendingOrderMutation>;
export type AssignCoachingModalAssignPendingOrderMutationOptions =
  Apollo.BaseMutationOptions<
    AssignCoachingModalAssignPendingOrderMutation,
    AssignCoachingModalAssignPendingOrderMutationVariables
  >;
